import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type TaskDetailsCountersSubscriptionVariables = GraphQLTypes.Exact<{
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  order?: GraphQLTypes.InputMaybe<GraphQLTypes.SortInput>;
  taskDetailsFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.TaskDetailsFiltersInput>;
}>;

export type TaskDetailsCountersSubscriptionResult = { __typename?: 'Subscription' } & {
  taskDetails?: GraphQLTypes.Maybe<
    { __typename?: 'WorkflowTaskDetailsPayloadType' } & Pick<
      GraphQLTypes.WorkflowTaskDetailsPayloadType,
      'activeTaskCount' | 'allOpenTaskCount' | 'allUnassignedTaskCount' | 'completedTaskCount'
    >
  >;
};

export const TaskDetailsCountersDocument = gql`
  subscription taskDetailsCounters(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: SortInput
    $taskDetailsFiltersInput: TaskDetailsFiltersInput
  ) {
    taskDetails(
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
      taskDetailsFiltersInput: $taskDetailsFiltersInput
    ) {
      activeTaskCount
      allOpenTaskCount
      allUnassignedTaskCount
      completedTaskCount
    }
  }
`;
